import { poundToKiloGram } from '@/utils/unit-converter'
import round from 'lodash-es/round'
import { DataPoint } from '@/jsonapi/CommonTypes'
import { VuetifyThemeItem } from 'vuetify/types/services/theme'
import { buildSummaryReportLineChartOption } from '@/components/patient-stats/graphs/summary-reports/chart-options/summary-line-chart/build-summary-report-line-chart-options'

export function buildBodyWeightChartOption(options: {
  bodyWeights: DataPoint[]
  bodyWeightsRollingAvg: DataPoint[]
  timezone: string
  startTimestamp: number
  endTimestamp: number
  colors: VuetifyThemeItem | any // FIXME
}): any {
  const { bodyWeights, bodyWeightsRollingAvg, timezone, startTimestamp, endTimestamp, colors } = options
  const unitAppliedBodyWeights = bodyWeights.map(dp => ({
    ...dp,
    value: poundToKiloGram(dp.value),
  }))
  const unitAppliedBodyWeightsRollingAvg = bodyWeightsRollingAvg.map(dp => ({
    ...dp,
    value: poundToKiloGram(dp.value),
  }))

  const dpMaxY = Math.max(...unitAppliedBodyWeights.map(dp => dp.value))
  const dpMinY = Math.min(...unitAppliedBodyWeights.map(dp => dp.value))
  const diffBetweenMinAndMaxDp = Math.max(10, dpMaxY - dpMinY)
  const maxY = round(dpMaxY + diffBetweenMinAndMaxDp * 0.125)
  const minY = round(dpMinY - diffBetweenMinAndMaxDp * 0.125)
  const centerY = round((maxY + minY) / 2)

  return buildSummaryReportLineChartOption({
    startTimestamp,
    endTimestamp,
    timezone,
    actualDataPoints: unitAppliedBodyWeights,
    rollingAvgDataPoints: unitAppliedBodyWeightsRollingAvg,
    lineColor: colors.lavender,
    unitLabel: 'kg',
    markLineNumbers: [centerY, maxY],
    maxY,
    minY,
  })
}
